export const errorMessage = (error: unknown) =>
  error instanceof Error ? error.message : 'Request failed'

export const shortDate = (value: string | null) =>
  value
    ? new Date(value).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    : 'None'

export const dateTime = (value: string | null) =>
  value
    ? new Date(value).toLocaleString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      })
    : 'None'

export function dateRange(startsAt: string, endsAt: string) {
  const start = shortDate(startsAt)
  const end = shortDate(endsAt)
  return start === end ? start : `${start} to ${end}`
}

export function downloadCsv(filename: string, rows: (string | number | null)[][]) {
  const escape = (cell: string | number | null) => {
    const text = cell === null ? '' : String(cell)
    // Leading = + - @ would run as a formula when ops open the file in a spreadsheet.
    const safe = /^[=+\-@]/.test(text) ? `'${text}` : text
    return /[",\n]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe
  }
  const blob = new Blob([rows.map((row) => row.map(escape).join(',')).join('\n')], {
    type: 'text/csv;charset=utf-8',
  })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

export const CHECK_LABELS: Record<string, string> = {
  booth_paid: 'Did not pay a booth fee',
  fee_remaining: 'Booth fee already refunded',
  payment_verified: 'Paid the organizer offline',
  checked_in: 'Not checked in',
  sales_count: 'Too few in-person sales',
  sales_cents: 'In-person sales value too low',
}
